import React from 'react';
import { Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function DisclaimerPopup({ onAccept }) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}
      data-testid="disclaimer-popup"
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 sm:p-8 space-y-5 animate-in fade-in zoom-in-95">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-full" style={{ backgroundColor: '#FEF3C7' }}>
            <Shield className="h-6 w-6" style={{ color: '#D97706' }} />
          </div>
          <h2 className="text-xl sm:text-2xl font-bold" style={{ color: '#1C1917', fontFamily: '"Cormorant Garamond", serif' }}>
            Important Disclaimer
          </h2>
        </div>

        <div className="p-4 rounded-xl border-2" style={{ backgroundColor: '#FFFBEB', borderColor: '#FCD34D' }}>
          <p className="text-sm sm:text-base leading-relaxed" style={{ color: '#78350F' }}>
            "Prayan Pilgrim Services is an independent private service and is not the official website
            or representative of Sree Parashurama Temple or its Devaswom. We provide online booking
            assistance for poojas and religious services for the convenience of devotees. All bookings
            and services are subject to the rules, timings, availability, and decisions of the Temple authorities."
          </p>
        </div>

        <Button
          onClick={onAccept}
          className="w-full text-lg font-semibold p-6 rounded-xl"
          style={{ backgroundColor: '#16A34A', color: 'white' }}
          data-testid="disclaimer-accept-btn"
        >
          I Understand & Continue
        </Button>
      </div>
    </div>
  );
}
